import store from '../../store';
import { onlyNumbers } from '../../utils/formatters';
import { sendRollbarError } from '../../services/rollbar';
import { updateSubscription } from '../../reducers/subscription';

export const createMercadoPagoToken = async (setFormErrors) => {
  let subscription = store.getState().subscription;
  setFormErrors([]);

  const expiry = subscription.creditCardExpiry.split(' / ')
  
  try {
    const response = await window.mp.createCardToken({
      cardNumber: onlyNumbers(subscription.creditCardNumber),
      cardholderName: subscription.creditCardHolderName,
      cardExpirationMonth: expiry[0],
      cardExpirationYear: expiry[1],
      securityCode: subscription.creditCardCvc,
      identificationType: 'CPF',
      identificationNumber: onlyNumbers(subscription.cpf),
    })

    store.dispatch(updateSubscription({
      mercadoPagoToken: response.id
    }));
  }
  catch(e) {
    const errors = e.map((i) => i.message)

    sendRollbarError('mercadoPagoTokenNotCreated', { error: errors.join(', ') });
    store.dispatch(updateSubscription({
      mercadoPagoToken: ''
    }));
    setFormErrors(errors);
  }
}